<template>
  <div id="coach_success_outer">
    <div class="big-notice-label">
      恭喜您完成身份认证审核！
    </div>
    <div class="small-notice-label">
      {{timeValue}}s将自动跳转至<a href="javascript:void(0)" @click="gotoCertListPage">我的认证>></a>
    </div>
  </div>
</template>

<script>
import EventManager from "../../../js/event-common";

export default {
  name: "CoachSuccessVue",
  props: {
    coachItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      timeValue: 5,
      timeTimer: null,
      updateSuccess: false,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    eventManager() {
      return this.$store.state.eventManager;
    }
  },
  mounted() {
    if (this.coachItem != null) {
      let status = this.coachItem.coach.status;
      if (status == 7) {
        console.log('---- success -- 1');
        this.startTimer();
        this.updateStatus(7);
      }
    }
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    updateStatus(status) {
      let params = {};
      let coachItem = this.coachItem;
      params.status = status;
      if (params.status == 7) {
        params.auditStatus = 0;
      } else {
        params.auditStatus = coachItem.coach.auditStatus;
      }
      params.id = coachItem.coach.id;
      let _this = this;
      this.httpManager.ajax.postCoachStatusUpdateRequest(params, function(data) {
        console.log(data);
        console.log('upate coach status succeed!');
        let code = data.code;
        if (code == 0) {
          _this.updateSuccess = true;
          return;
        }
        _this.$toast('数据更新失败');
        // failure(data);
      }, function(data) {
        _this.$toast('数据更新失败');
        // failure(data);
      });
    },

    startTimer() {
      let _this = this;
      this.timeTimer = setInterval(function () {
        _this.timeValue -= 1;
        if (_this.timeValue < 0) {
          _this.clearTimer();
          _this.gotoCertListPage();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timeTimer != null) {
        clearInterval(this.timeTimer);
        this.timeTimer = null;
      }
    },
    gotoCertListPage() {
      if (!this.updateSuccess) {
        this.updateStatus(7);
        return;
      }
      this.eventManager.postNotification(EventManager.notificationNameObject.coachApplicationSuccess, null);
      this.$router.push({
        name: 'personalCertificatesVue'
      });
    }
  }
}
</script>

<style scoped>

  #coach_success_outer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    min-height: 250px;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    background-color: white;
    width: 90%;
    max-width: 500px;
    /* border: solid 1px #eee; */
    border-radius: 4px;
  }

  #coach_success_outer .big-notice-label {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 40px;
  }


  #coach_success_outer .small-notice-label {
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    margin-top: 70px;
  }

  #coach_success_outer .small-notice-label a {
    color: #fc1a34;
  }


</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/CoachSuccess.vue